<template>
  <v-container fluid class="customer-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/customer/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="isFindCustomer=true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_customers.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="customers-table"
              show-select
              single-select
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="data_customers"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteCustomer"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Customer?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_customer.customername }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteCustomer = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_customer)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.customerimage="{ item }">
                  <img v-if="item.customerimage" v-bind:src="item.customerimage" alt="" width="80">
              </template>
              <template v-slot:item.customername="{ item }">
                <a class="primaryConst--text">{{ item.customername }}</a>
                <p>{{ item.customertype }}</p>
              </template>
              <template v-slot:item.customeraddress="{ item }">
                <a class="primaryConst--text">{{ item.customeraddress }}</a>
                <p class="two-line">{{ item.customerphone  }}</p>
                <p class="two-line">{{ item.customermobile  }}</p>
              </template>
              <template v-slot:item.townshipid="{ item }">
                <p class="two-line">{{ item.regionid!=undefined && regions.find(region=>region._id == item.regionid)!=null ? regions.find(region=>region._id == item.regionid)['regionname'] : ''   }}</p>
                <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                <a class="primaryConst--text" target="_blank" v-bind:href="'http://maps.google.com/maps?q=' + item.geolocation.replace(' ', '')">Map</a>
              </template>
              <template v-slot:item.customerstatus="{ item }">
                <v-chip
                  :color="item.customerstatus=='Active' ? 'successConst white--text' : item.claimstatus=='New' ? 'primaryConst white--text' : item.claimstatus=='Inactive' ? 'greyTint white--text' : 'primaryConst white--text'"
                  small>
                  {{ item.customerstatus }}
                </v-chip>
              </template>
              <template v-slot:item.lastOrderDate="{ item }">
                <p v-if="item.lastOrderDate" class="two-line"><span style="font-size: x-small;">Last:</span> {{ new Date(item.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.createdAt="{ item }">
                <p class="two-line">{{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) }}</p>
                <p class="two-line">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </p>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn v-if="item.customerstatus!='Inactive'" icon color="primary" @click="updateCustomerInvoiceSendDialog(item)">
                  <v-icon>mdi-text-box-edit</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindCustomer"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Customers</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    :items="users.filter(x=>x.userstatus=='Active').map(x => {
                              return {text: x.username, value: x._id};
                            })"
                    v-model="find_query.userid"
                    label="Sales Rep"
                    required
                  ></v-select>
                  <v-select
                    :items="regions.filter(x=>x.regionstatus=='Active').map(x => {
                              return {text: x.regionname, value: x._id};
                            })"
                    v-model="find_query.regionid"
                    label="Region"
                    required
                  ></v-select>
                  <v-select
                    :items="townships.filter(x=>x.townshipstatus=='Active' && x.regionid==find_query.regionid).map(x => {
                              return {text: x.townshipname, value: x._id};
                            })"
                    v-model="find_query.townshipid"
                    label="Township"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="find_query.enddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter end date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_enddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_enddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindCustomer = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetSalesOrders"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findCustomers"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isCustomerInvoiceSend"
        persistent
        width="400px"
        max-width="800px"
      >
          <v-card>
            <v-card-title>
              <span class="text-h5">Send Statement</span>
            </v-card-title>
            <v-card-text>
              {{ invoice_send.customername }}
            </v-card-text>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model="invoice_send.confirm"
                      required
                      dense
                      persistent-hint
                      single-line hint="Type the word 'Send'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isCustomerInvoiceSend=false; invoice_send={}"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="invoice_send.confirm!=='Send'"
                @click="updateCustomerInvoiceSend"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-row>
    <div>

    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CustomerList',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'customerimage', sortable: false, width: "5%" },
        { text: 'Name', value: 'customername', width: "10%"},
        { text: 'Address', value: 'customeraddress', width: "15%"},
        { text: 'Location', value: 'townshipid' },
        
        { text: 'Orders', value: 'lastOrderDate' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Status', value: 'customerstatus', width: "7%"},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,

      

      data_customers: [],
      isDeleteCustomer: false,
      isCustomerInvoiceSend: false,
      delete_customer: {},
      isFindCustomer: false,
      find_query: {},
      invoice_send: {},
      menu_startdate: null,
      menu_enddate: null,   
    }
  },
  computed: {
    ...mapState('Customer', ['customers', 'isReceiving', 'isDeleting', 'idToDelete', 'customersMessage', 'isUpdating']),
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('ItemCategory', ['itemcategories']),
    ...mapState('ItemGroup', ['itemgroups']),
    ...mapState('Location', ['locations']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  async created () {
    if(this.customers.length==0) await this.getCustomersRequest();
    this.data_customers = this.customers;
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.itemcategories.length==0) await this.getItemCategoriesRequest();
    if(this.itemgroups.length==0) await this.getItemGroupsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
  methods: {
    ...mapActions('Brand', ["getBrandsRequest"]),
    ...mapActions('Customer', ["getCustomersRequest", "findCustomersQueryRequest", "deleteCustomerRequest", "updateCustomerInvoiceSendRequest"]),
  
    ...mapActions('Item', ["getItemsRequest"]),
    ...mapActions('ItemCategory', ["getItemCategoriesRequest"]),
    ...mapActions('ItemGroup', ["getItemGroupsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    async deleteItem(item) {
      this.isDeleteCustomer = false;
      await this.deleteCustomerRequest({_id: item._id});
      this.data_customers = this.customers;
    },
    deleteDialog(item) {
      this.isDeleteCustomer = true;
      this.delete_customer = {_id: item._id,customername: item.customername};
    },
    editItem(item) {
      this.$router.push({ name: 'CustomerEdit', params: item })
    },
    async findCustomers(){
      this.isFindCustomer = false;
      if(this.find_query=={}){
        await this.getCustomersRequest();
        this.data_customers = this.customers;
      }
      else{
        let result = await this.findCustomersQueryRequest(this.find_query);
        this.data_customers = result;
      }
    },
    getJson(){
      let json = this.data_customers.map(customer=>{return {
        customername: customer.customername, 
        type: customer.customertype,
        address: customer.customeraddress,
        phone: customer.customerphone,
        mobile: customer.customermobile,
        region: customer.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == customer.regionid)['regionname'] : '',
        township: customer.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == customer.townshipid)['townshipname'] : '',
        salesrep: customer.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == customer.userid)['username'] : '',
        createddate: customer.createdAt!=undefined ? new Date(customer.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        lastorder: customer.lastOrderDate!=undefined ? new Date(customer.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        map: 'http://maps.google.com/maps?q=' + customer.geolocation.replace(' ', ''),
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'customers-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    getBrands(list){
      let results = list.map(obj=> this.brands.find(brand=>brand._id==obj).brandname);
      return results.join(", ");
    },
    getItems(lists){
      let results = lists.map(obj=> this.items.find(item=>item._id==obj).itemname);
      return results.join(", ");
    },
    getCategories(lists){
      let results = lists.map(obj=> this.itemcategories.find(category=>category._id==obj)!=null ? this.itemcategories.find(category=>category._id==obj).itemcategoryname : '');
      return results.join(", ");
    },
    getGroups(lists){
      let results = lists.map(obj=> this.itemgroups.find(group=>group._id==obj)!=null ? this.itemgroups.find(group=>group._id==obj).itemgroupname : '');
      return results.join(", ");
    },
    async resetSalesOrders(){
      this.find_query = {};
    },
    viewItem(item) {
      this.$router.push({ name: 'CustomerView', params: item })
    },
    updateCustomerInvoiceSendDialog(item) {
      this.isCustomerInvoiceSend = true;
      this.invoice_send = { _id: item._id, customername: item.customername };
    },
    async updateCustomerInvoiceSend() {
      this.isCustomerInvoiceSend = false;
      let result = await this.updateCustomerInvoiceSendRequest(this.invoice_send);
      let index = this.data_customers.findIndex((x) => x._id == result._id);
      this.data_customers.splice(index, 1, result);
      this.invoice_send = {};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
